import * as React from 'react';
const RashCutaneoIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M71.04 57.06s8.4 10.24 21.4 10.33c9.23.07 16.39 1.4 23.59 8.99 7.79 8.22 12.32 19.06 12.86 30.31.29 6.04-.3 13.36-2.84 21.54M103.03 129.94c-5.31-8.37-.37-26.14-.37-26.14s-1.22 9.37-6.79 17.29c0 0 1.14 15.07-4.89 25.85"
      className="prefix__cls-2"
    />
    <path
      d="M74.75 85.45s5.37-5.02 16.91-6.37M95.86 121.09s-4.14 7.56-24.82 8.66"
      className="prefix__cls-2"
    />
    <path
      d="M97.06 94.3c.1-.03.15-.13.12-.23a.18.18 0 0 0-.23-.12.18.18 0 0 0-.12.23c.03.1.13.15.23.12M110.24 99.13c.1-.03.15-.13.12-.23a.18.18 0 0 0-.23-.12.18.18 0 0 0-.12.23c.03.1.13.15.23.12M107.91 91.79a3.242 3.242 0 1 0-1.93-6.19 3.242 3.242 0 0 0 1.93 6.19"
      className="prefix__cls-1"
    />
  </svg>
);
export default RashCutaneoIcon;
